export default __webpack_public_path__ + "media/images/images_v2/admin-hover-27443983a0d1e4bf0f1099a364a1aeeb.png";